import { isLocationBelowLevel, CREATE_IN_FS_LEVEL } from '@fielded/fs-api/lib/location/tools'
import { isSelfSignup, hasOwnDatabase } from './index'

export const isLeadUser = (user, location) => {
  if (!location) {
    return isLeadBeforeSync(user, location)
  }

  if (!(location.additionalData && location.additionalData.level)) {
    return false
  }

  return isLocationBelowLevel(location, CREATE_IN_FS_LEVEL)
}

export const isLeadBeforeSync = (user, location) => {
  const userWithNoDBorNoLocationYet = !hasOwnDatabase(user) || (hasOwnDatabase(user) && !location)
  return isSelfSignup(user) && userWithNoDBorNoLocationYet
}
